import { Component } from "@angular/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";

import { ApplicationWizardService } from "../application-wizard.service";
import { AbstractWizardStepComponent } from "../../../wizard-dialog/abstract-wizard-step.component";
import { ApplicationPortsComponent } from "../application-ports/application-ports.component";
import { ApplicationSelectTypeComponent } from "../application-select-type/application-select-type.component";
import { ValidationService } from "../../../../common/validation/validation.service";

@Component({
	templateUrl: "./application-web-url.component.html"
})
export class ApplicationWebUrlComponent extends AbstractWizardStepComponent<void> {
	public form: FormGroup;

	constructor(
		private service: ApplicationWizardService,
		private formBuilder: FormBuilder,
		private validationService: ValidationService
	) {
		super();

		this.form = this.formBuilder.group({
			webUrl: [
				this.service.getValue("webUrl", ""),
				Validators.compose([
					Validators.required,
					this.validationService.webUrl
				])
			]
		});
	}

	public get title() {
		return this.service.applicationState.isCreate ?
			"application.wizard.title.create" : "application.wizard.title.update";
	}

	public get description() {
		return "applicaiton.wizard.webUrl.description";
	}

	public get nextStep() {
		return ApplicationPortsComponent;
	}

	public get previousStep() {
		return ApplicationSelectTypeComponent;
	}

	public get isFormValid() {
		return this.form.valid;
	}

	public performPrevious() {
		this.service.processWebUrl(this.webUrl);
	}

	public performNext() {
		this.service.processWebUrl(this.webUrl);
	}

	public get showProgressBar() {
		return false;
	}

	private get webUrl(): string {
		return this.form.getRawValue().webUrl;
	}
}
